module.exports = __webpack_public_path__ + "static/media/r451.357c3be6.jpg";